$(document).foundation();

jQuery(document).on('gform_confirmation_loaded', function(event, formId) {
  // hide spinner
  jQuery('.gform_ajax_spinner').hide();
  // hide validation messages
  jQuery('.gform_wrapper.gravity-theme h2.gform_submission_error').hide()
  jQuery('.gform_wrapper.gravity-theme .validation_message').hide()
  // clear out fields
  jQuery('.gform_wrapper.gravity-theme input[type="text"], .gform_wrapper.gravity-theme textarea').val('')
  jQuery('.gform_wrapper.gravity-theme input[type="checkbox"]').prop('checked', false)
  /// message
  var daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var today = new Date();
  var currentDayOfWeek = daysOfWeek[today.getDay()];
  jQuery('.gform_footer').find('p').remove()
  jQuery('.gform_footer').append('<p class="confirmation-message">Have a great ' + currentDayOfWeek + '.</p>')
  // button label
  jQuery('.gform_footer').find('button').addClass('button-submitted').html('Thanks! We\'ll be in touch.')
  // scroll to bottom of form
  //$('html, body').animate({ scrollTop: offsetTop }, 250);
  var scrollHeight = jQuery('.contact-sidebar').prop('scrollHeight')
  jQuery('.contact-sidebar').animate({ scrollTop: scrollHeight }, 250);
});

jQuery(document).ready(function($) {

  baSlider("#ba-slider");

  // if (window.location.href.indexOf('c=1') > -1) {
  //   setTimeout(function() {
  //     $('a[data-toggle="contactSidebar"]').trigger('click')
  //   }, 2000)
  // }

  var fromHash = false

  // work ajax
  var workViewMode = 'grid'
  var workCategory = 0
  function getWork() {
    $('.grid-view-list-content').css('visibility', 'hidden')
    var url = '/work/?view-mode=' + workViewMode
    if (workCategory > 0) {
      url += '&category-term-id=' + workCategory
    }
    $.ajax({
      url: url,
      cache: false,
      dataType: 'html'
    }).done(function(html) {
      var searchResultsHtml = $(html).find('.grid-view-list-content').html()
      $('.grid-view-list-content').html(searchResultsHtml).css('visibility', 'visible')
      // google analytics
      if (typeof _gaq !== 'undefined') {
        _gaq.push(['_trackPageview'])
      }
      history.pushState(null, null, url)
      projectCollectionsInit()
      ScrollTrigger.refresh(true)
    }).fail(function(error) {
      alert('Error loading ' + url)
    })
  }

  function updateExploreMenu() {
    $('.explore-menu a').removeClass('hide')
    if (workViewMode == 'grid') {
      $('.explore-menu a[data-work-count="0"]').addClass('hide')
    }
  }

  // toggle grid and list
  $('.view-toggle a').on('click', function(e) {
    if ($(this).index() == 0) {
      workViewMode = 'grid'
      $('main').removeClass('list-view--is-showing')
    } else {
      workViewMode = 'list'
      $('main').addClass('list-view--is-showing')
    }
    $('.explore').removeClass('explore-menu--is-showing')
    updateExploreMenu
    getWork()
    e.preventDefault()
  })

  // collection toggles
  function projectCollectionsInit() {
    $('.project-collection .toggle').on('click', function(e) {
      var $projectCollections = $(this).parent()
      $projectCollections.toggleClass('project-collection--is-showing')
      e.preventDefault()
    })
  }
  projectCollectionsInit()

  // collections menu
  $('.single-work .collections-menu .current').on('click', function() {
    $('.single-work .collections-menu').toggleClass('collections-menu--is-showing')
  })

  // studio - close bios
  $('.grid-bio .close').on('click', function() {
    $('.cell-person').removeClass('cell-person--is-inactive')
    $('.cell-person').removeClass('cell-person--is-active')
    $('.cell-person').removeClass('cell-person--text-is-hidden')
    $('.grid-bio').removeClass('grid-bio--is-showing')
  })

  // explore menu
  $('.explore h3').on('click', function() {
    updateExploreMenu()
    $('.explore').toggleClass('explore-menu--is-showing')
  })

  $('.explore-menu a').on('click', function(e) {
    workCategory = $(this).data('category-term-id')
    $('.explore .activator .current').html($(this).html())
    $('.explore').removeClass('explore-menu--is-showing')
    getWork()
    e.stopPropagation()
    e.preventDefault()
  })

  // $('.explore').hover(
  //   function() {},
  //   function() {
  //     $('.explore').removeClass('explore-menu--is-showing')
  //   }
  // )

  // mobile toggle
  $('.mobile-toggle').on('click', function(e) {
    $('body').toggleClass('nav--menu--is-open')
    e.preventDefault()
    e.stopPropagation()
  })

  // mobile menu height
  $(window).on('resize', function() {
    // mobile menu
    $('.mobile-menu').css({ height: window.innerHeight })
    ScrollTrigger.refresh(true)
  }).trigger('resize')

  // studio - show bio
  $('.cell-person:not(.cell-person--no-questions)').on('click', function() {
    var $person = $(this)
    var postId = $person.data('post-id')
    var personId = $person.data('person-id')
    // deactivate all other people
    $('.cell-person').addClass('cell-person--is-inactive').removeClass('cell-person--is-active')
    $person.removeClass('cell-person--is-inactive').addClass('cell-person--is-active')
    // hide names of people in same row
    var $gridPeople = $person.closest('.grid-x')
    $('.cell-person').removeClass('cell-person--text-is-hidden')
    $gridPeople.find('.cell-person').addClass('cell-person--text-is-hidden')
    $person.removeClass('cell-person--text-is-hidden')
    // show matching bio
    var $bio = $('.grid-bio[data-post-id="' + postId + '"]')
    $('.grid-bio').removeClass('grid-bio--is-showing')
    $bio.addClass('grid-bio--is-showing')
    setTimeout(function() {
      var unitOffset = $person.offset().top + 2
      if (Foundation.MediaQuery.current == 'small') {
        unitOffset -= 65
      } else if (fromHash) {
        unitOffset -= 90
        fromHash = false
      }
      $('html, body').animate({ scrollTop: unitOffset }, 250, function() {
        ScrollTrigger.refresh(true)
      })
    }, 600)
    setTimeout(function() {
      $('body').addClass('page-scrolling-down').removeClass('page-scrolling-up')
    }, 1000)
  })

  // homepage hero toggle
  $('.hero .toggle').on('click', function() {
    $('.page-template-page-home').toggleClass('hero--is-active')
    if ($('.page-template-page-home').hasClass('hero--is-active')) {
      setTimeout(function() {
        var unitOffset = $('main').offset().top
        $('html, body').animate({ scrollTop: unitOffset }, 1000)
      }, 6000)

    }
  })

  function openPerson(personId) {
    if (Foundation.MediaQuery.current == 'small') {
      $('.team-small .cell-person[data-person-id="' + personId + '"]').trigger('click')
    } else {
      $('.team-medium .cell-person[data-person-id="' + personId + '"]').trigger('click')
    }
  }

  // cell hi footer
  $('.cell-hi a').on('click', function() {
    var href = $(this).attr('href')
    var hash = href.substring(href.indexOf('#'))
    if (hash.indexOf('person-id-') > -1) {
      var personId = hash.replace('#person-id-', '')
      openPerson(personId)
    }
  })

  // scroll up down detector
  var lastScrollTop = 0
  $(window).on('scroll', function() {
    var st = $(this).scrollTop();
    if (st > lastScrollTop){
      $('body').addClass('page-scrolling-down').removeClass('page-scrolling-up')
    } else {
      $('body').removeClass('page-scrolling-down').addClass('page-scrolling-up')
    }
    if (st == 0) {
      $('body').removeClass('page-scrolling-down').removeClass('page-scrolling-up')
    }
    lastScrollTop = st;
  })

  // carousel
  $('.carousel-container').each(function() {
    var $carouselContainer = $(this)
    var $carousel = $carouselContainer.find('.carousel').flickity({
      cellSelector: '.carousel-cell',
      setGallerySize: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      wrapAround: false,
      on: {
        select: function() {
          if ($carousel) {
            var currentIndex = $carousel.data('flickity').selectedIndex
            // update caption
            $carouselContainer.find('.counter .current').html(currentIndex + 1)
            // update caption
            var $cell = $carousel.find('.carousel-cell').eq(currentIndex)
            $carouselContainer.find('.carousel-caption').html($cell.find('.carousel-cell-caption').html())
          }
        },
        staticClick: function(event, pointer, cellElement, cellIndex) {
          if ($carousel) {
            $carousel.flickity('select', cellIndex)
          }
        }
      }
    })
    $carouselContainer.find('.next').on('click', function() {
      if ($carousel.data('flickity').selectedIndex == $carousel.find('.carousel-cell').length - 1) {
        $carousel.flickity('select', 0)
      } else {
        $carousel.flickity('next')
      }
    })

    $carouselContainer.find('.previous').on('click', function() {
      if ($carousel.data('flickity').selectedIndex == 0) {
        $carousel.flickity('select', $carousel.find('.carousel-cell').length - 1)
      } else {
        $carousel.flickity('previous')
      }
    })
  })


  // scrolltriggers

  // approach
  if ($('.page-template-page-approach').length > 0) {
    window.scrollTo(0, 0);
    var currentIndex = 0;
    gsap.utils.toArray('.step').forEach((step, index) => {
      gsap.from(step, {
        opacity: 0,
        y: 0,
        scrollTrigger: {
          trigger: step,
          start: 'top 50%', // Adjust this value as needed
          end: 'bottom 50%',
          toggleActions: 'play none none reverse', // Only play on enter, no reverse
          markers: false,
          onEnter: () => {
            moveToStep(index);
            console.log(`Step ${index + 1} is in view`); // Log the current step index when entering
          },
          onEnterBack: () => {
            moveToStep(index);
            console.log(`Step ${index + 1} is currently in view while scrolling back`); // Log when scrolling back
          }
        }
      });
    });

    function moveToStep(index) {
      var stepHeight = $(window).width() < 768 ? 480 : 330
      currentIndex = index
      // extend line
      var lineIndex = index
      if (lineIndex >= $('.step').length) {
        lineIndex = $('.step').length - 1
      }
      gsap.to('.line', {
        height: stepHeight * lineIndex,
        duration: 0.50, // Adjust the duration as needed
        ease: "power1.out",
        overwrite: true,
      });
      // move orange dot
      gsap.to('.orange', {
        top: (stepHeight * index) - 0,
        duration: 0.50,
        ease: "power1.out",
        opacity: 1,
        overwrite: true,
        onStart: () => {
          $('.gray-dots .dot').each(function(dotIndex) {
            var $dot = $(this)
            var timeOut = 0
            if ($(this).index() <= index) {
              setTimeout(() => {
                $dot.addClass('dot--is-showing')
              }, timeOut)
            } else {
              $dot.removeClass('dot--is-showing')
            }
          })
        }
      });
      // fade in dot
      $('.gray-dots .dot').each(function(dotIndex) {
        if ($(this).index() == index) {
          $(this).addClass('dot--is-active')
        } else {
          $(this).removeClass('dot--is-active')
        }
      })
      // fade in step
      $('.steps-content .step').each(function(stepIndex) {
        if ($(this).index() == index) {
          $(this).addClass('step--is-showing')
        } else {
          $(this).removeClass('step--is-showing')
        }
      })
    }

    $('a.with-arrow').on('click', function(e) {
      e.preventDefault()
    })
    
    var stepsContainer = document.querySelector('.steps-container');
    if (stepsContainer) {
      ScrollTrigger.create({
        trigger: stepsContainer,
        start: 'top 60%', // When the top of the container hits the bottom of the viewport
        end: 'top 60%', // When the top of the container hits the top of the viewport
        onLeave: () => {
          console.log('.steps-container has scrolled out of view while scrolling up');
        },
        onLeaveBack: () => { // New callback for when scrolling back up
          console.log('.steps-container top is no longer visible');
          gsap.to('.line', {
            height: 0,
            duration: 0,
            overwrite: true
          });
          gsap.to('.orange', {
            top: 0,
            duration: 0,
            opacity: 0,
            overwrite: true
          });
          $('.gray-dots .dot').removeClass('dot--is-active').removeClass('dot--is-showing')
        }
      });
    }

  }

  if ($('.single-work').length > 0) {
    $('.video-container').each(function() {
      var $videoContainer = $(this)
      var mediaElement = $videoContainer.find('video')[0]
      gsap.timeline({
        scrollTrigger: {
          trigger: $videoContainer,
          start: 'top 70%',
          end: 'top 0%',
          scrub: true,
          markers: false,
          onEnter: (self) => {
            mediaElement.play()
            console.log('PLAY - onEnter')
          },
          onEnterBack: (self) => {
            mediaElement.play()
            console.log('PLAY - onEnterBack')
          },
          onLeave: (self) => {
            mediaElement.pause()
            console.log('PAUSE - onLeave')
          },
          onLeaveBack: (self) => {
            mediaElement.pause()
            console.log('PAUSE - onLeaveBack')
          },
        }
      })
    })
  }

  // hero
  gsap.timeline().to('.content-fade-in', { delay: 0.5, opacity: 1, ease: 'power2.out', duration: 2 })

  // // hero parts
  // if ($('.content-fade-in-parts').length > 0) {
  //   var spanCount = 1
  //   $('.content-fade-in-parts span').each(function() {
  //     var $span = $(this)
  //     gsap.timeline().to($span, { opacity: 1, ease: 'power2.out', duration: 1, delay: spanCount * 1.5 })
  //     spanCount++
  //   })
  // }

  // home hide logo
  if ($('.page-template-page-home').length > 0) {
    if (Foundation.MediaQuery.current == 'small') {
      gsap.timeline({
        scrollTrigger: {
          trigger: '.featured-projects',
          start: 'top 60%',
          end: 'top 50%',
          scrub: true,
          markers: false
        }
      })
      .to('.logo-container', { opacity: 0, ease: 'power2.out' })
    } else {
      gsap.timeline({
        scrollTrigger: {
          trigger: '.featured-projects',
          start: 'top 70%',
          end: 'top 60%',
          scrub: true,
          markers: false
        }
      })
      .to('.logo-container', { opacity: 0, ease: 'power2.out' })
    }
  }

  // change nav color
  if ($('.hero').length > 0) {
    var scrollTriggerSettings = {
      trigger: '.hero',
      start: 'bottom top',
      end: 'bottom top',
      scrub: true,
      markers: false
    }
    gsap.timeline({
      scrollTrigger: scrollTriggerSettings
    })
    .to('body', { opacity: 1,
      onStart: function() {
        $('body').addClass('page-hero-scrolled')
      },
      onReverseComplete: function() {
        $('body').removeClass('page-hero-scrolled')
      }
    })
  }

  // animation of content
  $('.content-move-fade').each(function() {
    var $content = $(this)
    var scrollTriggerSettings = {
      trigger: $content,
      start: 'top 80%',
      end: 'top 30%',
      scrub: true,
      markers: false
    }
    if (Foundation.MediaQuery.is('medium down')) {
      scrollTriggerSettings.start = '-10% 100%'
      scrollTriggerSettings.end = 'top 75%'
    }
    if ($content.hasClass('image')) {
      scrollTriggerSettings.start = 'top 70%'
    }
    if ($content.hasClass('content-move-fade-fast')) {
      scrollTriggerSettings.start = 'top 90%'
      scrollTriggerSettings.end = 'top 80%'
    }
    if ($content.hasClass('content-move-fade-instant')) {
      scrollTriggerSettings.start = 'top 100%'
      scrollTriggerSettings.end = 'top 80%'
    }
    var tl = gsap.timeline({
      scrollTrigger: scrollTriggerSettings
    })
    .from($content, { y: 100, opacity: 0 } )
  })

  // back to top scroll on work page
  if ($('.single-work').length > 0) {
    gsap.timeline({
      scrollTrigger: {
        trigger: 'main',
        start: '45% 25%',
        end: '50% top',
        scrub: true,
        markers: false
      }
    })
    .from('.back-to-top', { bottom: -200 })
  }

  if ($('.page-template-page-work').length > 0) {
    gsap.timeline({
      scrollTrigger: {
        trigger: 'main',
        start: '50% 25%',
        end: '55% top',
        scrub: true,
        markers: false
      }
    })
    .from('.back-to-top', { bottom: -200 })
  }

  // back to top
  $(window).on('resize', function() {
    var diff = $(window).width() - $('footer .grid-x').first().width()
    diff = diff / 4 - 50
    $('.back-to-top').css({
      right: diff
    })
  }).trigger('resize')

  $('.back-to-top').on('click', function () {
    $('html, body').animate({ scrollTop: 0 }, 500)
  })

  // show hero text after two seconds
  setTimeout(function() {
    $('.hero .text').addClass('text--is-showing')
  }, 2000)


  // scroll to top
  // load images
  $('body img').imagesLoaded().done( function( instance ) {
    $('html, body').animate({ scrollTop: 0 }, 0)
    $('body').addClass('body-images--done-loading')
    ScrollTrigger.refresh(true)
    var hash = window.location.hash
    if (hash.indexOf('person-id-') > -1) {
      fromHash = true
      var personId = hash.replace('#person-id-', '')
      openPerson(personId)
    }

    const urlParams = new URLSearchParams(window.location.search);
    const sectionIdFromQuery = urlParams.get('section');

    if (sectionIdFromQuery) {
      console.log('sectionIdFromQuery', sectionIdFromQuery)
      const $targetSection = $('div.section[data-section-id="' + sectionIdFromQuery + '"]');
      console.log('targetSection', $targetSection)
      if ($targetSection.length) {
        const isMobile = $(window).width() < 768
        const offsetTop = $targetSection.offset().top - (isMobile ? 140 : 200);
        const scrollToPosition = Math.max(0, offsetTop); // Prevent negative scroll values

        setTimeout(function() {
          $('html, body').animate({ scrollTop: scrollToPosition }, 0, function() {
            // Refresh ScrollTrigger after the animation completes
            ScrollTrigger.refresh(true);
          });
        }, 500)
      }
    }

  })

  setTimeout(function() {
    $('body').addClass('body-images--done-loading')
    ScrollTrigger.refresh(true)
  }, 3000)

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })
  
  
})











